import { Link } from "react-router-dom";
import { PlaceholderBadge, SectionLabel } from "../components/site/Blocks";
import useStatusStore from "../store/statusStore";
import { getClosureText } from "../config/hours";
import { LOCATION, SITE_NAME } from "../config/location";
import { FAMILY } from "../config/content";

// TODO Inhalt Kunde: Platzhalter in config/content.js (FAMILY).
const UeberUns = () => {
    const closure = useStatusStore((state) => state.closure);
    const closureText = closure && getClosureText(closure);

    return (
        <>
            <section className="sec page-head grid-2 !items-end pb-20">
                <div className="eyebrow hero-in" style={{ animationDelay: ".1s" }}>
                    Über uns
                </div>
                <h1
                    className="h1-page m-0 max-w-[900px] xwide:max-w-[1200px] !text-[clamp(40px,5vw,72px)] xwide:!text-[clamp(72px,3.8vw,98px)] !leading-[1.06] hero-in"
                    style={{ animationDelay: ".25s" }}
                >
                    Griechische Gastfreundschaft in Weingarten.
                </h1>
            </section>

            <section className="sec">
                <div className="mask relative">
                    <PlaceholderBadge />
                    <img
                        src="/media/gastraum.jpg"
                        alt="Gastraum"
                        className="block h-[clamp(320px,50vh,560px)] w-full object-cover object-[center_40%]"
                    />
                </div>
            </section>

            <section className="sec sec-y-md grid-2-3">
                <SectionLabel>Herzlich willkommen</SectionLabel>
                <div className="max-w-[720px] text-[19px] xwide:text-[21px] leading-[1.75] text-forest/80">
                    <p className="reveal mt-0 mb-7 font-caslon text-[clamp(24px,2.4vw,32px)] xwide:text-[clamp(32px,2vw,44px)] leading-[1.4] text-forest">
                        Schön, dass Sie da sind.
                    </p>
                    <p className="reveal d1 mt-0 mb-6">
                        Bei uns kommen griechische und deutsche Küche auf den Tisch, saisonal und mit mediterranem
                        Flair.
                    </p>
                    <p className="reveal d2 mt-0 mb-6">
                        Mittags gibt es zusätzlich unsere Mittagskarte. Wir freuen uns
                        auf Ihren Besuch und wünschen Ihnen einen angenehmen Aufenthalt.
                    </p>
                    <p className="reveal d2 m-0 font-caslon text-[22px] xwide:text-[26px] italic">Ihr Team vom {SITE_NAME}</p>
                </div>
                {/* Nur auf breiten Schirmen: füllt die rechte Hälfte */}
                <div className="reveal reveal-scale hidden wide:block">
                    <img
                        src="/media/meze-tisch.jpeg"
                        alt="Gedeckter Tisch mit Meze"
                        loading="lazy"
                        className="block aspect-[3/2] w-full object-cover"
                    />
                </div>
            </section>

            <section className="sec sec-y-md grid-3 bg-leinen">
                <SectionLabel>Neue Adresse</SectionLabel>
                <div>
                    <h2 className="h2-sec reveal mb-5 h2-sec-sm">
                        Neues Zuhause: die <span className="whitespace-nowrap">{LOCATION.venue}.</span>
                    </h2>
                    <p className="body-text reveal d1 m-0 max-w-[480px]">
                        {/* Nennt der Schließhinweis die Adresse schon selbst, entfällt der eigene Satz */}
                        {!closureText?.period.includes(LOCATION.street) &&
                            `Sie finden uns in der ${LOCATION.street} in ${LOCATION.town}. `}
                        {closureText && `${[closureText.period, closureText.reopen].filter(Boolean).join(" ")} `}
                        <Link to="/kontakt" className="underline">
                            Anfahrt und Öffnungszeiten
                        </Link>
                    </p>
                </div>
                <div className="reveal d2 relative">
                    <PlaceholderBadge />
                    <img
                        src="/media/aussen.jpg"
                        alt="Außenansicht am Abend"
                        loading="lazy"
                        className="block aspect-[4/3] desk:aspect-[3/2] w-full object-cover object-[55%_50%]"
                    />
                </div>
            </section>

            <section className="sec sec-y-md grid-2-3">
                <SectionLabel>Küche &amp; Team</SectionLabel>
                <div className="max-w-[640px]">
                    <h2 className="h2-sec reveal mb-6 h2-sec-sm">
                        Ein Familienbetrieb. Vater und Sohn am Grill und im Service.
                    </h2>
                    {FAMILY.story.map((paragraph, index) => (
                        <p key={index} className="body-text reveal d2 mt-0 mb-5">
                            {paragraph}
                        </p>
                    ))}
                </div>
                <div className="mt-6 desk:mt-0">
                    <div className="grid gap-5 desk:grid-cols-3">
                        <div className="mask">
                            <img
                                src="/media/team.jpeg"
                                alt="Vater und Sohn, die Inhaber"
                                loading="lazy"
                                className="block aspect-[4/5] w-full object-cover object-[center_30%]"
                            />
                        </div>
                        <div className="mask">
                            <img
                                src="/media/dolmadakia.jpeg"
                                alt="Dolmadakia werden serviert"
                                loading="lazy"
                                className="block aspect-[4/5] w-full object-cover"
                            />
                        </div>
                        <div className="mask">
                            <img
                                src="/media/am-grill.jpeg"
                                alt="Lammkoteletts"
                                loading="lazy"
                                className="block aspect-[4/5] w-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default UeberUns;
